import { com } from '@eidu/web'
import EntityWithLabelAndRelated from '../domain/entity/EntityWithLabelAndRelated'
import useEntityById from './useEntityById'
import entityIdFromStringOrNull = com.eidu.entity.entityIdFromStringOrNull
import { getRuntimeIdFromEntity } from './entityRuntimeIdLink'

const useRuntimeEntity = (entity: EntityWithLabelAndRelated | undefined) => {
  const runtimeIdString = entity !== undefined ? getRuntimeIdFromEntity(entity) : undefined
  const runtimeEntityId = runtimeIdString ? entityIdFromStringOrNull(runtimeIdString) ?? undefined : undefined

  const { entity: runtimeEntity, loading } = useEntityById(runtimeEntityId)

  if (entity === undefined) {
    return { runtimeEntityId: undefined, runtimeEntity: undefined, loading: false }
  }

  return { runtimeEntityId, runtimeEntity, loading }
}

export default useRuntimeEntity
